export const BASE_PATH = '/s/tsx';
